<template>
     <div v-if="this.questionModel.answered">
        <!-- <button v-if="this.questionModel.id != 0" class="w3-xlarge w3-button w3-round w3-black w3-gray w3-margin" v-on:click="$emit('change-question', $event, questionModel.id - 1)" > Précedent </button> -->
        <div class="greeting-check-circle"></div>
        <p class="greeting-answer-detail" v-html="this.questionModel.language[$parent.quizData.language].answerDetail"></p>
    </div>
</template>

<script>
export default {
  name: 'Greeting',
  props: ['questionModel']
}
</script>
